import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const SAFETY_FAERS_CODE: {
  FAERS_TARGET_PRODUCT_BATCH_RAN_CANNOT_ADD_MAPPING: MvnCodeBE;
  FAERS_PRODUCT_GENERIC_NAME_TOO_LONG: MvnCodeBE;
  FAERS_DRUG_SEARCH_UNSUPPORTED_QUERY: MvnCodeBE;
  FAERS_EXTERNAL_FETCH_FAILED: MvnCodeBE;
  FAERS_EXTERNAL_TIMEOUT: MvnCodeBE;
  FAERS_EXTERNAL_RATE_LIMITED: MvnCodeBE;
} = {
  FAERS_TARGET_PRODUCT_BATCH_RAN_CANNOT_ADD_MAPPING: {
    status: 400,
    ko: "배치가 수행된 후에는 매핑 정보를 추가할 수 없습니다.",
    en: "FAERS mapping cannot be added after a batch has been run.",
  },
  FAERS_PRODUCT_GENERIC_NAME_TOO_LONG: {
    status: 500,
    ko: "FAERS 약물명 길이가 시스템 허용치를 초과했습니다.",
    en: "FAERS drug name exceeds the system storage limit.",
  },
  FAERS_DRUG_SEARCH_UNSUPPORTED_QUERY: {
    status: 400,
    ko: "지원하지 않는 검색어입니다. 영문 약물명으로 검색해 주세요.",
    en: "This search term isn't supported. Please search by an English drug name.",
  },
  FAERS_EXTERNAL_FETCH_FAILED: {
    status: 503,
    ko: "외부 데이터 조회에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    en: "Failed to fetch external data. Please try again later.",
  },
  FAERS_EXTERNAL_TIMEOUT: {
    status: 504,
    ko: "외부 데이터 응답이 지연되고 있습니다. 잠시 후 다시 시도해 주세요.",
    en: "External data response timed out. Please try again later.",
  },
  FAERS_EXTERNAL_RATE_LIMITED: {
    status: 429,
    ko: "외부 데이터 호출이 일시적으로 제한되었습니다. 잠시 후 다시 시도해 주세요.",
    en: "External data calls are temporarily rate-limited. Please try again later.",
  },
};

MvnCodeInitiate(SAFETY_FAERS_CODE);
